import {IConvertedContactsResult, IReturningContactsCard, IReturningContactsCardTypes} from '@/entities/response'


// TODO: replace this static data later
export const convertedDetractors: IReturningContactsCard = {
    metrics: 'nps',
    description: 'Promoters Turned Detractors',
    total: 0,
    totalImage: '/img/icon/promoters-to-detractors.svg',
    underThreshold: false,
    type: IReturningContactsCardTypes.convertedDetractors,
    first: {
        description: 'Promoters Turned Detractors',
        location: 'Richmond',
        total: 638,
        topic: 'Service'
    },
    second: {
        description: 'Promoters Turned Detractors',
        location: 'Kingsland',
        total: 242,
        topic: 'Price'
    },
    third: {
        description: 'Promoters Turned Detractors',
        location: "St Mary's",
        total: 638,
        topic: 'Service'
    }
}

export const convertedPromoters: IReturningContactsCard = {
    metrics: 'nps',
    description: 'Detractors Turned Promoters',
    total: 0,
    totalImage: '/img/icon/detractors-to-promoters.svg',
    underThreshold: false,
    type: IReturningContactsCardTypes.convertedPromoters,
    first: {
        description: 'Detractors Turned Promoters',
        location: 'Kingsland',
        total: 182,
        topic: 'Friendliness'
    },
    second: {
        description: 'Detractors Turned Promoters',
        location: 'Lincoln',
        total: 382,
        topic: 'Communication'
    },
    third: {
        description: 'Detractors Turned Promoters',
        location: "Somerset",
        total: 152,
        topic: 'Knowledge'
    }
}

export const cardLayoutConsts = {
    [IReturningContactsCardTypes.convertedDetractors]: {
        trend: ' of these DETRACTORS INDICATE',
        acion: 'NEED TO FOCUS ON',
        subTrend: 'Also pay attention to:',
        subAction: ' needing to focus on ',
        note: ''
    },
    [IReturningContactsCardTypes.convertedPromoters]: {
        trend: ' OF THESE PROMOTERS INDICATE',
        acion: 'EXCEL IN',
        subTrend: 'Also learn from:',
        subAction: ' excelling in ',
        note: 'The above numbers are calculcated to identify the group that has made the biggest impact (not the largest number of responses)'
    }
}

export const convertedContactsThreshold: IConvertedContactsResult = {
    number: 5,
    emptyStateMessage: 'There is not enough data to provide actionable insights',
}

